// extracted by mini-css-extract-plugin
module.exports = {"error":"FormCommonError__error__BBzjS"};